import React from "react";
import CalendarDatePicker from "ui/components/comp-507";
import DepartmentCombobox from "components/directus/department-combobox";
import { PermissionGate } from "permissions/components/gate";
import useTableFilters from "@/hooks/useTableFilters";

const TimesheetEmployeeFilters = ({
  filters,
  setFilters,
  defaultFilters,
  showDepartment = true,
}) => {
  const handleDateRangeChange = (dateRange) => {
    setFilters({
      ...filters,
      startDate: dateRange?.from || undefined,
      endDate: dateRange?.to || undefined,
    });
  };

  useTableFilters({
    filters,
    setFilters,
    initialFilters: {
      ...defaultFilters,
    },
  });

  const dateRange = {
    from: filters?.startDate,
    to: filters?.endDate,
  };

  return (
    <div className="flex items-center space-x-4 w-full">
      {showDepartment && (
        <DepartmentCombobox
          value={filters?.department}
          onChange={(value) => setFilters({ ...filters, department: value })}
          hideLabel
          className="w-full max-w-md"
        />
      )}

      <CalendarDatePicker
        date={dateRange}
        setDate={handleDateRangeChange}
        placeholder="Pick a date range"
      />
    </div>
  );
};

export default TimesheetEmployeeFilters;
